/* Client-IP country lookup used to pre-select the country on signup.
 *
 * The resolution happens server-side (`GET /api/v1/geo/country`) so the
 * browser never talks to a third-party geo service directly. Always
 * best-effort: any failure resolves to `null` and the form keeps its
 * default. */

const CACHE_KEY = "oe_geo_country";

export async function detectCountry(): Promise<string | null> {
  // Within one browser session the answer cannot change — skip the round-trip.
  try {
    const cached = window.sessionStorage.getItem(CACHE_KEY);
    if (cached) return cached || null;
  } catch {
    /* storage disabled — just do the request */
  }

  try {
    const res = await fetch("/api/v1/geo/country", { credentials: "same-origin" });
    if (!res.ok) return null;
    const data = (await res.json()) as { country: string | null };
    const code = data?.country ?? null;
    try {
      window.sessionStorage.setItem(CACHE_KEY, code ?? "");
    } catch {
      /* ignore */
    }
    return code;
  } catch {
    return null;
  }
}
